import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { clearTypeahed, fetchAllTypeaheadOS } from '../../../actions';
import MultiTypeahead from './MultiTypeahead';
import renderMultiSuggestion from '../RenderMultiSuggestion';

class OSTypeahead extends Component {
    static propTypes = {
        fetchAllTypeaheadOS: PropTypes.func.isRequired,
        suggestions: PropTypes.array,
        error: PropTypes.string,
        onChangeSuggestion: PropTypes.func.isRequired,
        clearTypeahed: PropTypes.func,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
        renderMultiSuggestion: PropTypes.func
    };

    static defaultProps = {
        suggestions: [],
        renderMultiSuggestion
    };

    state = {
        isLoading: false
    };

    onFocus = async () => {
        this.setState({ isLoading: true });

        try {
            await this.props.fetchAllTypeaheadOS(OSTypeahead.name);
        } finally {
            this.setState({ isLoading: false });
        }
    };

    render() {
        let options = [];
        if (this.props.suggestions.length) {
            options = this.props.suggestions.map(os => ({
                label: os.name, value: os.id
            }));
        }

        return (
            <MultiTypeahead
                options={options || []}
                isMulti
                disabled={this.props.disabled}
                required={false}
                isLoading={this.state.isLoading}
                value={this.props.value}
                titleId="OS"
                animatedPlaceholder={this.props.animatedPlaceholder}
                onChangeSuggestion={this.props.onChangeSuggestion}
                handleSuggestionsClearRequested={this.props.clearTypeahed}
                onFocus={this.onFocus}
                formatOptionLabel={this.props.renderMultiSuggestion}
                error={this.props.error}
                t={this.props.t}
            />
        );
    }
}

const mapStateToProps = ({ typeahead }) => ({
    suggestions:
        typeahead.source === OSTypeahead.name
            ? typeahead.list
            : OSTypeahead.defaultProps.suggestions
});

export default connect(mapStateToProps, {
    fetchAllTypeaheadOS,
    clearTypeahed
})(OSTypeahead);
